import { Box, VStack, Text, Stack, FormLabel, Input, Image } from '@chakra-ui/react';
import React from 'react';
import { IMG } from '../../../Content/Content';

const Products = () => {
    return (
        <VStack w="100%" paddingY="50px">
            <Box textAlign="left" w="100%">
                <Text
                    fontSize="30px"
                    fontWeight="500"
                    color="rgba(0, 0, 0, 0.84)"
                    position="relative" className='Title_product' paddingLeft="20px" _before={{
                        position: "absolute",
                        left: "0",
                        right: "0",
                        height: "100%",
                        background: " linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%)",
                        width: "9px"
                    }}>Products</Text>
            </Box>

            {/* add Product */}
            <Stack flexDirection="row" flexWrap="wrap" w="100%" alignItems="start" justifyContent={'start'}>
                <Box w="33%" marginTop="10px">
                    <Box position="relative" w="100%" display="flex" alignItems="center" padding="20px" justifyContent="center" overflow="hidden">
                        <Box h="300" w="100%" bg="#F5F5F5" boxShadow=" 0px 4px 4px rgba(0, 0, 0, 0.25)"
                            display="flex" alignItems="center" justifyContent="center">
                            <FormLabel display="flex">
                                <Input type="file" display="none" />
                                <Text paddingRight="10px">Upload image</Text> <Image src={IMG.UploadImage} />
                            </FormLabel>
                        </Box>

                    </Box>
                </Box>

                <Box w="33%">
                    <Box position="relative" w="100%" display="flex" flexDirection="column" alignItems="center" padding="20px" justifyContent="center" overflow="hidden">
                        <Box h="300" w="100%" bg="#F5F5F5" boxShadow=" 0px 4px 4px rgba(0, 0, 0, 0.25)"
                            display="flex" alignItems="center" justifyContent="center">
                                <Image src={IMG.Product1} w="100%" objectFit={'cover'} h="100%"></Image>
                        </Box>
                        <Text fontSize="24px" paddingY="10px" fontWeight="400" color="rgba(0, 0, 0, 0.84)">
                            Product name
                        </Text>    

                    </Box>
                </Box>

                <Box w="33%">
                    <Box position="relative" w="100%" display="flex" flexDirection="column" alignItems="center" padding="20px" justifyContent="center" overflow="hidden">
                        <Box h="300" w="100%" bg="#F5F5F5"  boxShadow=" 0px 4px 4px rgba(0, 0, 0, 0.25)"
                            display="flex" alignItems="center" justifyContent="center">
                                <Image src={IMG.Product2} w="100%" objectFit={'cover'} h="100%"></Image>
                        </Box>
                        <Text fontSize="24px" paddingY="10px" fontWeight="400" color="rgba(0, 0, 0, 0.84)">
                            Product name
                        </Text>    

                    </Box>
                </Box>

            </Stack>
        </VStack>
    );
};

export default Products;